export default function itemsReducer(state = {itemsFetched: false}, action) {
    switch (action.type) {
        case "FETCHING_ITEMS":
            return state;
        case "ITEMS_RESPONSE":
            return {...state, itemsFetched: true, items: action.payload}
        case "ADDING_ONLY_ITEMS":
            return {...state, onlyItems: action.payload}
        default:
            return state;
    }
}